module.exports = __webpack_public_path__ + "static/media/seeds-of-change-tablet.27f899ff.jpg";